<style type="text/scss" lang="scss">
  @import '../../styles/vars';

  .form {
    background: white;
    padding: 16px;
    border-radius: 4px;
    box-shadow: 0 2px 2px 0 rgba(23, 28, 33, 0.06);
    position: relative;
    margin-bottom: 16px;
  }

  .form.frameless {
    box-shadow: none;
    margin: 0;
  }

  .form :global(select) {
    appearance: none;
    -webkit-appearance: none;
    width: 100%;
    background-color: #f7f7f8;
    border: none;
    box-shadow: none;
    border-radius: 4px;
    font-family: proxima-nova, sans-serif;
    font-weight: 500;
    color: #4c4c4b;
    font-size: 16px;
    padding: 12px 8px;
    margin: 0;
    height: auto;
    line-height: initial;
    background-position: right 3px center;
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' version='1.1' width='32' height='24' viewBox='0 0 32 24'><polygon points='0,0 32,0 16,24' style='fill: rgb%28202, 202, 202%29'></polygon></svg>");
  }

  .form :global(input) {
    appearance: none;
    width: 100%;
    background: #f7f7f8;
    border: none;
    box-shadow: none;
    border-radius: 4px;
    font-family: proxima-nova, sans-serif;
    font-weight: 500;
    color: #4c4c4b;
    font-size: 16px;
    padding: 12px 8px;
  }

  .form :global(input:focus) {
    outline: none;
    border: none;
    box-shadow: none;
    background-color: darken(#f7f7f8, 2);
  }

  .form :global(input:disabled) {
    background: #f7f7f8;
  }

  .form :global(input[readonly]) {
    background: #f7f7f8;
  }

  .form :global(textarea) {
    appearance: none;
    width: 100%;
    background: #f7f7f8;
    border: none;
    box-shadow: none;
    border-radius: 4px;
    font-family: proxima-nova, sans-serif;
    font-weight: 500;
    color: #4c4c4b;
    font-size: 16px;
    padding: 12px 8px;
    min-height: 160px;
  }

  .form :global(textarea:focus) {
    outline: none;
    border: none;
    box-shadow: none;
    background-color: darken(#f7f7f8, 2);
  }

  .form :global(textarea[readonly]) {
    background: #f7f7f8;
  }

  .form :global(select:focus) {
    outline: none;
    border: none;
    box-shadow: none;
    background-color: darken(#f7f7f8, 2);
  }

  .form :global(select.placeholder) {
    color: #cacaca;
  }

  .form :global(label) {
    font-family: proxima-nova, sans-serif;
    color: #4c4c4b;
    font-weight: 700;
    font-size: 11px;
    line-height: 21.034px;
    text-transform: uppercase;
    margin: 0 0 4px 0;
  }

  .form :global(.form-group) {
    margin-bottom: 16px;
  }

  .form :global(.form-group-repeater) {
    background-color: #f7f7f8;
    padding: 16px;
    border-radius: 4px;
    margin-bottom: 16px;
    width: 100%;
  }

  .form :global(.form-group-add) {
    background: #4e4e4e;
    padding: 16px;
    margin: 0 0 0 0;
    border-radius: 4px;
    width: 100%;
    color: #fff;
    width: 100%;
    text-align: center;
    cursor: pointer;

    font-family: proxima-nova, sans-serif;
    font-weight: 500;
  }

  .form :global(.help) {
    padding: 4px 8px;
    border-radius: 4px;
    background: #fbfbfb;
    font-family: proxima-nova, sans-serif;
    color: #4c4c4b;
    font-weight: 600;
    font-size: 11px;
    line-height: 21.034px;
    text-transform: uppercase;
    margin-bottom: 16px;
    display: inline-block;
  }

  .form :global(.save) {
    border-radius: 4px;
    background: #ff6452;
    font-family: proxima-nova, sans-serif;
    font-weight: 600;
    font-size: 12px;
    line-height: 21.034px;
  }

  .form :global(.delete) {
    border-radius: 4px;
    font-family: proxima-nova, sans-serif;
    background: #4e4e4e;
    font-weight: 600;
    font-size: 12px;
    line-height: 21.034px;
  }
</style>

<script>
  export let frameless = false;
</script>

<div class="form" class:frameless="{frameless}">
  <slot></slot>
</div>
